import { useContext } from 'react'
import { EditorDocContext } from '../EditorProviderContext'

export const useEditorDoc = () => {
  const context = useContext(EditorDocContext)

  if (!context) {
    throw new Error(`useEditorDoc is only available inside EditorProvider`)
  }

  return context
}
